import { gql } from "@/__generated__/gql";

export const CREATE_DATA_MANAGEMENT_FILE_MUTATION = gql(`
  mutation CreateDataManagementFile(
    $organizationId: ID!
    $file: Upload!
  ) {
    createDataManagementFileMutation(input: {
      organizationId: $organizationId
      file: $file
    }) {
      dataManagementFile {
        id
        name
        url
        createdAt
      }
      errors {
        title
        message
      }
    }
  }
`);
